import * as React from "react"

import { cn } from '../../utils';

const textInputClasses =
  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

const checkboxClasses = cn(
  "relative inline-flex h-6 w-6 shrink-0 appearance-none items-center justify-center rounded-full border-2 border-input bg-background text-current transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  "before:pointer-events-none before:absolute before:h-3 before:w-3 before:rounded-full before:bg-current before:opacity-0 before:transition before:duration-150 before:content-[''] before:scale-0",
  "checked:before:scale-100 checked:before:opacity-100",
);

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type = "text", ...props }, ref) => {
    const baseClasses = type === "checkbox" ? checkboxClasses : textInputClasses;

    return (
      <input
        type={type}
        className={cn(
          baseClasses,
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
